import * as React from 'react';

export default class Home extends React.Component {
    render() {
        return (
            <div>
                no content
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/module/homePage/home.tsx